import { Image } from '@chakra-ui/react';

const TeamAvatar = ({ src }: { src: any }) => (
    <Image
        boxSize="40px"
        borderRadius="8px"
        objectFit="cover"
        src={src}
        alt="team avatar"
        fallbackSrc="https://via.placeholder.com/40"
    />
);

export default TeamAvatar;
